export default (function () {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/noop.js
// module id = 113
// module chunks = 0